import { Card, CardContent } from "@/components/ui/card";
import BrandHero from "@/components/app/BrandHero";

export default function GetStartedPage() {
  return (
    <div className="space-y-8" data-testid="get-started-page">
      <BrandHero
        overline="Get started"
        title="Set yourself up for success"
        description="Your shortcuts to Assessment, Goals, Reminders, Leading Edge Academy, and Show Plans live in the sidebar — work through them in any order."
        testid="get-started-hero"
      />
      <Card className="border-border shadow-none rounded-lg">
        <CardContent className="p-10 sm:p-14 flex flex-col items-center text-center gap-3">
          <h3 className="font-display text-2xl font-extrabold tracking-tight">This page is yours</h3>
          <p className="text-sm text-muted-foreground max-w-md">
            Add your own intro text here later. Until then, use the links under
            <strong> Get Started</strong> in the sidebar to start building your dog&apos;s plan.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
